import script from "./IndicatorPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicatorPanel.vue?vue&type=script&setup=true&lang=js"

import "./IndicatorPanel.vue?vue&type=style&index=0&id=b79b7e06&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b79b7e06"]])

export default __exports__